import React, { Fragment, useEffect, useState } from 'react';
import { Map, TileLayer, Marker, Popup, Polyline } from 'react-leaflet';
import redPin from '../../../../../assets/svg/redPin.svg';
import greenPin from '../../../../../assets/svg/greenPin.svg';
import { Icon } from 'leaflet';
import { makeStyles } from '@material-ui/core/styles';
import Neshan from '../../../../../api/neshan';
import poly from '@mapbox/polyline';

const useStyles = makeStyles((theme) => ({
  breifAddress: {
    position: 'absolute',
    top: 10,
    left: 10,
    zIndex: 500,
    background: '#1e31929c',
    color: '#fff',
    padding: theme.spacing(0, 1),
    width: '80%',
  },
}));

// import NeshanMap from "react-neshan-map-leaflet";

const redPinIcon = new Icon({
  iconUrl: redPin,
  iconSize: [25, 25],
  iconAnchor: [12.5, 25],
  popupAnchor: [0, -25],
});
const greenPinIcon = new Icon({
  iconUrl: greenPin,
  iconSize: [25, 25],
  iconAnchor: [12.5, 25],
  popupAnchor: [0, -25],
});

const BreifMap = ({ order }) => {
  const classes = useStyles();
  const [values, setValues] = useState({});
  const { summary, positions } = values;

  const markers = [
    {
      title: `بارگیری:${order.origin.title}`,
      location: order.origin.location.coordinates,
    },
    {
      title: `تخلیه:${order.destination.title}`,
      location: order.destination.location.coordinates,
    },
  ];

  const loadSummary = async () => {
    try {
      const { data } = await Neshan.get(
        `https://api.neshan.org/v2/direction/no-traffic?type=car&origin=${order.origin.location.coordinates[0]},${order.origin.location.coordinates[1]}&destination=${order.destination.location.coordinates[0]},${order.destination.location.coordinates[1]}
        `
      );
      const positions =
        data && data.routes[0].overview_polyline.points
          ? data.routes[0].overview_polyline.points
          : '';
      const posArray = poly.decode(positions);
      setValues({
        summary: data.routes[0].legs[0],
        positions: posArray,
      });
    } catch (error) {
      console.error(JSON.stringify(error, null, 2));
    }
  };

  useEffect(() => {
    loadSummary();
  }, []);
  return (
    <Fragment>
      {summary ? (
        <div className={classes.breifAddress}>
          {summary.summary}
          <br />
          {`مسافت: ${summary.distance.text}`}
          <br />
          {`مدت زمان: ${summary.duration.text}`}
        </div>
      ) : null}
      <Map center={[31.879685, 54.4068077]} zoom={5}>
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <Marker position={markers[0].location} icon={redPinIcon}>
          <Popup>{markers[0].title}</Popup>
        </Marker>
        <Marker position={markers[1].location} icon={greenPinIcon}>
          <Popup>{markers[1].title}</Popup>
        </Marker>
        {/* {markers.map((marker, i) => (
          <React.Fragment key={i}>
            <Marker position={marker.location} icon={icon}>
              <Popup>{marker.title}</Popup>
            </Marker>
          </React.Fragment>
        ))} */}
        {positions && positions.length ? (
          <Polyline positions={positions} />
        ) : null}
      </Map>
    </Fragment>
  );
};

export default React.memo(BreifMap);
